import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConfirmationDialog } from 'acscp/components/common/confirmationDialog';

interface FlightRequestConfirmationDialogProps {
    isOpen: boolean;
    closeDialog: () => void;
    action: () => void;
}

const FlightRequestConfirmationDialog: React.SFC<FlightRequestConfirmationDialogProps> =
    ({isOpen, closeDialog, action}) => (
        <ConfirmationDialog
            isOpen={isOpen}
            closeDialog={closeDialog}
            modalHeaderContent={
                <FormattedMessage
                    id={'components.flightRequest.form.flightRequestConfirmationDialog.flightRequest'}
                    defaultMessage={'NEW ENQUIRY'}
                />
            }
            confirmationContent={
                <FormattedMessage
                    id={'components.flightRequest.form.flightRequestForm.cancelRequestConfirmation'}
                    defaultMessage={'Are you sure you would like to cancel this enquiry?'}
                />
            }
            leftButtonContent={
                <FormattedMessage
                        id={'components.flightRequest.form.flightRequestConfirmationDialog.yes'}
                        defaultMessage={'YES'}
                />
            }
            leftButtonGreyedOut={true}
            leftButtonOnClick={action}
            rightButtonContent={
                <FormattedMessage
                        id={'components.flightRequest.form.flightRequestConfirmationDialog.no'}
                        defaultMessage={'NO'}
                />
            }
            rightButtonGreyedOut={false}
            rightButtonOnClick={closeDialog}
        />
    );

export { FlightRequestConfirmationDialog };
